import { Record } from "immutable";

/**
 * @type {Object}
 */
const EditorMentionRecord = Record({
  type: "",
  displayText: "",
  metadata: null,
  mutability: "SEGMENTED",
});

export default class EditorMention extends EditorMentionRecord {
  /**
   * @returns {EditorMention}
   */
  getDisplayText() {
    return this.get("displayText");
  }

  /**
   * @returns {String}
   */
  getType() {
    return this.get("type");
  }

  /**
   * @returns {*}
   */
  getMetadata() {
    return this.get("metadata");
  }

  /**
   * @returns {String}
   */
  getMutability() {
    return this.get("mutability");
  }

  /**
   * @param   {String} type
   * @param   {String} displayText
   * @param   {*}      metadata
   * @param   {String} mutability
   * @returns {EditorMention}
   */
  static create(type, displayText, metadata, mutability = "SEGMENTED") {
    return new EditorMention({
      type,
      displayText,
      metadata,
      mutability,
    });
  }

  /**
   * @param {String} type
   * @param {String} displayText
   * @param {String} mutability
   */
  static createWithoutMetadata(type, displayText, mutability = "SEGMENTED") {
    return new EditorMention({
      type,
      displayText,
      mutability,
    });
  }
}
